import { React, useState, useEffect } from "react";
import "../../components/DashboardModule/MyQuotations.css";
import { getSellerEnquiries, rejectSellerEnquiry } from "../../API/Api";
import PendingQuotesDetails from "./PendingQuotesDetails";
import { MoreVertical } from "lucide-react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const PendingQuotes = () => {
	const [showDetails, setShowDetails] = useState(false);
	const [enquiries, setEnquiries] = useState([]);
	const [loading, setLoading] = useState(true);
	const [selectedEnquiry, setSelectedEnquiry] = useState(null);

	useEffect(() => {
		const fetchEnquiries = async () => {
			try {
				const response = await getSellerEnquiries();
				if (response.status && response.data) {
					setEnquiries(response.data);
				}
				setLoading(false);
			} catch (error) {
				console.error("Error fetching enquiries:", error);
				setLoading(false);
			}
		};

		fetchEnquiries();
	}, []);

	const handleOpenClick = (enquiry) => {
		setSelectedEnquiry(enquiry);
		setShowDetails(true);
	};

	const handleBackClick = () => {
		setShowDetails(false);
	};

	const handleRejectClick = async (enquiryId) => {
		try {
			const response = await rejectSellerEnquiry(enquiryId);
			if (response.status) {
				toast.success("Reject Successful");
				const updatedResponse = await getSellerEnquiries();
				if (updatedResponse.status && updatedResponse.data) {
					setEnquiries(updatedResponse.data);
				}
			} else {
				toast.error(response.message || "Failed to reject enquiry");
			}
		} catch (error) {
			toast.error(error.response?.data?.message || "Error rejecting enquiry");
			console.error("Error rejecting enquiry:", error);
		}
	};

	if (showDetails && selectedEnquiry) {
		return (
			<PendingQuotesDetails
				onBack={handleBackClick}
				enquiry={selectedEnquiry}
				enquiryId={selectedEnquiry.enquiry_id}
			/>
		);
	}

	return (
		<div className="quo-container font-poppins">
			<div className="quo-header">
				<h2 className="quo-title">Pending Quotes</h2>
				<div className="quo-actions"></div>
			</div>

			<table className="quo-table">
				<thead>
					<tr>
						<th>RFQ ID</th>
						<th>Product Details</th>
						<th>Brand Name</th>
						<th>Date</th>
						<th>Status</th>
						<th>Action</th>
					</tr>
				</thead>
				<tbody>
					{enquiries.map((enquiry) => (
						<tr key={enquiry.enquiry_id}>
							<td>{enquiry.order_id}</td>
							<td>
								<div className="product-details">
									<div className="product-name">
										{enquiry.product_details.product_name}
									</div>
								</div>
							</td>
							<td>
								{enquiry.brands && enquiry.brands.length > 0 ? (
									enquiry.brands.map((brand, index) => (
										<span key={brand.id}>
											{brand.name}
											{index < enquiry.brands.length - 1 && ", "}
										</span>
									))
								) : (
									"...."
								)}
							</td>
							<td>
								{new Date(enquiry.product_details.created_at).toLocaleDateString()}
							</td>
							<td>{enquiry.status}</td>
							<td>
								<div className="quo-action-menu">
									<MoreVertical />
									<div className="quo-dropdown">
										<button
											className="text-quo font-poppins"
											onClick={() => handleOpenClick(enquiry)}
										>
											Preview
										</button>
										<button
											className="text-quo font-poppins"
											onClick={() => handleRejectClick(enquiry.enquiry_id)}
										>
											Reject
										</button>
									</div>
								</div>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};

export default PendingQuotes;